<div *ngIf="this.displaySpinner && actualProduct == undefined" class="loading-overlay-spinner">
    <mat-spinner></mat-spinner>
</div>

<!-- Part of page header -->
<div [ngClass]="data == undefined ? 'headerFull' : ''"></div>

<!-- Breadcrumb path on full page-->
<nav *ngIf="data == undefined" aria-label="breadcrumb" class="breadcrumb" role="navigation">
    <a [routerLink]="['/marktplatz']" [queryParams]="{ tab: 0 , category: 'Software'}">&nbsp;
        Marktplatz</a>&nbsp;&nbsp;
    <img class="arrow-icon-rg" src="assets/img/icons/arrow_down_green.png" alt="" width="10" height="10">
    <a class="category" *ngIf="actualProduct && actualProduct.category" [routerLink]="['/marktplatz']"
        [queryParams]="{ tab: 0, category: productCategory() }">&nbsp; {{ productCategory() }}
    </a>&nbsp;&nbsp;
    <img class="arrow-icon-rg" src="assets/img/icons/arrow_down_green.png" alt="" width="10" height="10">
    <span>&nbsp; {{ actualProduct?.name }}</span>
</nav>

<!-- Dialog header -->
<div *ngIf="data != undefined" class="dialog-header">
    <div style="display: flex; align-items: center; padding: 16px;">
        <div class="header-text-container">
            <div *ngIf="!this.displaySpinner && actualProduct != undefined">
                <h1 class="wordellipsis no-marginFull">
                    {{ actualProduct?.name }}
                </h1>
                <h2 class="pointerFull wordellipsis no-marginFull" (click)="
                        navigateToOrganisation(
                            organisation.organisationId
                        )
                    ">
                    {{ organisation?.organisationName }}
                </h2>

                <div #colmn1 *ngIf="actualProduct?.rating != 0" class="certificate-icon2Full">
                    <app-star (starClickEmitter)="goToRatingPane('show')" style="cursor: pointer"
                        [rating]="actualProduct?.rating" [ratingCount]="actualProduct?.ratingCount"></app-star>
                </div>
            </div>
            <app-image-slider [category]="'organisation'" [organisation]="this.organisation">
            </app-image-slider>
        </div>

    </div>
    <div class="bFull twocolumn-gridFull">
        <div #colmn2 class="certificate-iconFull">
            <app-certificate-simple-display *ngIf="
                ( actualProduct?.ptgCertificationCount &&
                actualProduct?.ptgCertificationCount > 0 ) ||
                (actualProduct?.attributeCertificationCount &&
                actualProduct?.attributeCertificationCount > 0 )
            " [certificateType]="'BIMSWARM_CERT'" [full]="true"
                [certCount]="totalCertificateCount"></app-certificate-simple-display>
            <div class="certificate-containerFull" *ngIf="enterprise">
                <div matTooltip="{{ certificationTooltip }}" [matTooltipPosition]="'above'" class="cert-imageFull"
                    [ngStyle]="{ 'background-image': 'url(' + certificationImageUrl + ')' }"></div>
                <p matTooltip="{{ certificationCountTooltip }}" [matTooltipPosition]="'below'">
                    Partner
                </p>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="right action-buttons" style="margin-bottom: 0;">
        <button class="btn-mg" matMiniFab color="accent" *ngIf="isLoggedIn()" matTooltip="Produkt markieren"
            (click)="toggleProductInList(actualProduct.id); bookmark($event)">
            <mat-icon style="color: var(--app-on-accent);">{{
                bookmarked ? 'bookmark' : 'bookmark_border'
                }}</mat-icon>
        </button>
        <button matMiniFab class=" open_in_new btn-mg" matTooltip="in neuem Tab öffnen"
            (click)="openInNewTab(actualProduct.id)" color="primary">
            <mat-icon style="color: var(--app-on-accent);">open_in_new</mat-icon>
        </button>
        <button matMiniFab class="back btn-mg" matTooltip="Seite schließen" (click)="cancel()" color="primary">
            <mat-icon style="color: var(--app-on-accent);">close</mat-icon>
        </button>
    </div>
</div>

<div [ngClass]="data == undefined ? 'fullpage-container' : ''">
    <!-- Full page header -->
    <div class="full-page-header" *ngIf="data == undefined">

        <div style="display: flex; align-items: center;">
            <div class="header-text-container">
                <div *ngIf="!this.displaySpinner && actualProduct != undefined">
                    <h1 class="wordellipsis no-marginFull" mat-dialog-title>
                        {{ actualProduct?.name }}
                    </h1>
                    <h2 class="pointerFull wordellipsis no-marginFull" (click)="
                        navigateToOrganisation(
                            organisation.organisationId
                        )
                    ">
                        {{ organisation?.organisationName }}
                    </h2>

                    <div #colmn1 *ngIf="actualProduct?.rating != 0" class="certificate-icon2Full">
                        <app-star (starClickEmitter)="goToRatingPane('show')" style="cursor: pointer"
                            [rating]="actualProduct?.rating" [ratingCount]="actualProduct?.ratingCount"></app-star>
                    </div>
                </div>
                <app-image-slider [category]="'organisation'" [organisation]="this.organisation">
                </app-image-slider>
            </div>

        </div>
        <div class="bFull twocolumn-gridFull">

            <div #colmn2 class="certificate-iconFull">
                <app-certificate-simple-display *ngIf="
                ( actualProduct?.ptgCertificationCount &&
                actualProduct?.ptgCertificationCount > 0 ) ||
                (actualProduct?.attributeCertificationCount &&
                actualProduct?.attributeCertificationCount > 0 )" [certificateType]="'BIMSWARM_CERT'" [full]="true"
                    [certCount]="totalCertificateCount">
                </app-certificate-simple-display>

                <div class="certificate-containerFull" *ngIf="enterprise">
                    <div matTooltip="{{ certificationTooltip }}" [matTooltipPosition]="'above'" class="cert-imageFull"
                        [ngStyle]="{ 'background-image': 'url(' + certificationImageUrl + ')' }"></div>
                    <p matTooltip="{{ certificationCountTooltip }}" [matTooltipPosition]="'below'">
                        Partner
                    </p>
                </div>

            </div>
        </div>
        <div mat-dialog-actions class="right">
            <button class="btn-mg" matMiniFab color="accent" *ngIf="isLoggedIn()" matTooltip="Produkt markieren"
                (click)="toggleProductInList(actualProduct.id); bookmark($event)">
                <mat-icon>{{
                    bookmarked ? 'bookmark' : 'bookmark_border'
                    }}</mat-icon>
            </button>
        </div>
    </div>

    <!-- Page Content -->
    @if (!this.displaySpinner && actualProduct != undefined) {
    <div [ngClass]="isFullPage? 'overflowFull' : 'overflowDialog'">

        <!-- image & description -->
        @if (!this.displaySpinner && actualProduct != undefined) {
        <div class="headFull">
            <div class="containerImage">
                <div class="containerFull">
                    <app-image-slider *ngIf="actualProduct.galleryFileIds != undefined" [item]="this.actualProduct"
                        [category]="'product'" [autoPlay]="true"></app-image-slider>
                </div>
                <span class="date-info">
                    <p *ngIf="actualProduct.publishDate != undefined">
                        Seit
                        {{ actualProduct?.publishDate | humanReadableDate }} auf
                        BIMSWARM
                    </p>
                    <p *ngIf="actualProduct.editDate != undefined">
                        Letztes Update:
                        {{ actualProduct?.editDate | humanReadableDate }}
                    </p>
                </span>
            </div>
            <div class="containerInfoFull">
                <div class="widthFull">
                    <div class="overview-container">
                        <h2> Produktübersicht </h2>
                        <mat-form-field appearance="fill" *ngIf="latestVersions.length > 0">
                            <mat-label>Produktvariante</mat-label>
                            <mat-select [(value)]="selectedVariant" (selectionChange)="onVariantChange($event)">
                                <mat-option *ngFor="let item of latestVersions" [value]="item.variant">
                                    {{ item.variant.name }}
                                </mat-option>
                            </mat-select>
                            <mat-icon matSuffix class="info-icon"
                                matTooltip="Es kann mehrere Varianten für ein Produkt geben. Sie werden verwendet bei unterschiedlichen Produktausführungen für die gleiche Zielgruppe und unterscheiden sich z.b. in Preis und Funktionsumfang. Beispiele: Free, Standard, Professional, Enterprise oder Kostenfrei, Kostenpflichtig oder Concurrent User, Named User."
                                tabindex="-1">
                                info_outline
                            </mat-icon>
                        </mat-form-field>
                    </div>
                    <div #descriptionContainer class="description-preview" [innerHTML]="combinedDescription">
                    </div>
                </div>
                <div class="btn-gridFull">
                    <button [disabled]="organisation?.contacts.length < 1 ||
                        this.disabledFeatures " matButton="elevated" (click)="requestDemo()" class="green-confirm">
                        Demo anfragen
                    </button>
                    <button matButton="elevated" color="accent" [disabled]="
                            this.actualProduct.url == null ||
                            this.actualProduct.url == undefined ||
                            this.actualProduct.url == ''
                        " (click)="routeToWebsite()">
                        Website
                    </button>
                    <button [disabled]="organisation?.contacts.length < 1 ||
                        this.disabledFeatures " matButton="elevated" (click)="requestOffer()" class="green-confirm">
                        Angebot anfragen
                    </button>
                </div>
            </div>
        </div>
        }

        <!-- Tab Content -->
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start"
            *ngIf="!this.displaySpinner && actualProduct != undefined" class="tabGroup" [(selectedIndex)]="selectedTab"
            (selectedTabChange)="onTabChange($event)">
            <mat-tab label="PRODUKTÜBERSICHT">
                <div *ngIf="this.actualProduct != null" class="featuretabFull tab-container" #tabContent>
                    <app-product-detail-display-feature-summary [product]="this.actualProduct"
                        [variant]="this.selectedVariant" [commonFeatures]="this.commonFeatures"
                        [preview]="this.data?.preview"></app-product-detail-display-feature-summary>
                </div>
            </mat-tab>

            <mat-tab [disabled]="this.actualProduct.id == null || this.disabledFeatures">
                <ng-template mat-tab-label>
                    <span *ngIf="this.actualProduct.id == null || this.disabledFeatures; else enabledDownload"
                        class="pointer-show" matTooltip="Für dieses Produkt nicht verfügbar"
                        [matTooltipPosition]="'above'">
                        DOWNLOADS
                    </span>
                    <ng-template #enabledDownload>
                        <span>DOWNLOADS</span>
                    </ng-template>
                </ng-template>

                <div class="clickableFull tab-container" #tabContent>
                    <app-product-detail-display-downloads
                        [fileIds]="this.actualProduct.documentFileIds"></app-product-detail-display-downloads>
                </div>
            </mat-tab>

            <mat-tab [disabled]="this.actualProduct.id == null || this.disabledFeatures">
                <ng-template mat-tab-label>
                    <span *ngIf="this.actualProduct.id == null || this.disabledFeatures; else enabledCert"
                        class="pointer-show" matTooltip="Für dieses Produkt nicht verfügbar"
                        [matTooltipPosition]="'above'">
                        ZERTIFIKATE
                    </span>
                    <ng-template #enabledCert>
                        <span>ZERTIFIKATE</span>
                    </ng-template>
                </ng-template>
                <div *ngIf="this.actualProduct != null" class="paddingFull tab-container" #tabContent>
                    <app-product-detail-display-certificates (navigationTriggered)="onNavigationTriggered()"
                        [product]="this.actualProduct"></app-product-detail-display-certificates>
                </div>
            </mat-tab>

            <mat-tab label="ANBIETER">
                <div class="paddingFull tab-container" #tabContent>
                    <app-product-detail-display-organisation [organisation]="this.organisation"
                        (navigationTriggered)="onNavigationTriggered()"></app-product-detail-display-organisation>
                </div>
            </mat-tab>

            <mat-tab [disabled]="this.actualProduct.id == null || this.disabledFeatures">
                <ng-template mat-tab-label>
                    <span [class.pointer-show]="actualProduct.id == null || disabledFeatures"
                        [matTooltip]="getReviewTooltip()" matTooltipPosition="above">
                        BEWERTUNGEN
                    </span>
                </ng-template>

                <div class="paddingFull tab-container" #tabContent>
                    <div id="ratingPane" #rating></div>
                    <app-marketplace-rating-extended [targetId]="actualProduct?.id" [reviewType]="reviewType"
                        [reviews]="reviews" [average]="average" [nrOfReviews]="nrOfReviews"
                        [showWriteReview]="showWriteReview" (reviewCloseEmitter)="showWriteReview = false"
                        (reviewOpenEmitter)="showWriteReview = true" (averageEmitter)="loadAverageScore()"
                        (statisticsEmitter)="loadReviewStatistic()"
                        (reviewEmitter)="loadReviews()"></app-marketplace-rating-extended>
                    <br />
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    }
</div>